import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { VNMappingService } from './vn-mapping.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SharedService } from '../../shared/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-VN-Mapping',
  templateUrl: './vn-mapping.component.html',
  styleUrls: ['./vn-mapping.component.css'],
})
export class VNMappingComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  displayedColumns: string[] = [
    'SNo',
    'forwarding_number',
    'virtual_number',
    'outlet_id',
    'lead_source_id',
    'lead_sub_source_id',
    'updatedAt',
    'createdAt',
    'status',
    'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public selectedId: number | null = null;
  virtualNumberForm: FormGroup;
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  dropdownData: any = {};
  vnType: any = ''; /** 1- OLD VN-MAP, 2- New VN-MAP(IVR) */
  constructor(
    private router: Router,
    private vnMappingService: VNMappingService,
    private toastr: ToastrService,
    private fb: FormBuilder, private sharedService: SharedService
  ) {
    this.virtualNumberForm = this.fb.group({
      status: ['', Validators.required],
      virtual_number: ['', Validators.required],
      forwarding_number: [''],
      fn_english_sales: [''],
      fn_english_non_sales: [''],
      fn_english_others: [''],
      fn_hindi_sales: [''],
      fn_hindi_non_sales: [''],
      fn_hindi_others: [''],
      fn_regional_sales: [''],
      fn_regional_non_sales: [''],
      fn_regional_others: [''],
      outlet_id: ['', Validators.required],
      lead_source: [''],
      lead_sub_source: [''],
      base_lead_source: ['', Validators.required],
    });
  }

  pageHandler(event: any) {
    this.pageLimit = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.getVirtualNumbers();
  }

  ngOnInit() {
    this.getVirtualNumbers();
    this.getDropDownData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  pageNumber: any = 1
  pageLimit: any = 10
  getVirtualNumbers() {
    this.isLoading.next(true);
    let queryParams: any = 'page=' + this.pageNumber + '&limit=' + this.pageLimit
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';

    if (filterValue) {
      queryParams += '&search=' + filterValue + '&filter=' + this.filterInput.value;
    }
    this.vnMappingService.getVirtualNumbers(queryParams).subscribe(
      (response) => {
        if (response.body.responseCode == 200) {
          this.ELEMENT_DATA = response.body.data.list;
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          setTimeout(() => {
            this.paginator.length = response.body.data?.totalItems
            this.paginator.pageIndex = this.pageNumber - 1
          }, 200)
          this.isLoading.next(false);
        } else {
          this.isLoading.next(false);
        }
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  outletList: any = []
  getDropDownData() {
    this.vnMappingService.getDropDownData().subscribe(
      (response) => {
        this.dropdownData = response.body.data;
        this.outletList = this.dropdownData.outlets.sort((a: any, b: any) => {
          return a.outlet_name.localeCompare(b.outlet_name);
        });
      },
      (error) => {
      }
    );
  }

  get f() { return this.virtualNumberForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.virtualNumberForm.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit && this.selectedId !== null) {
      const updateData = this.virtualNumberForm.value;
      console.log("vnType:", this.vnType)
      if (this.vnType == '2') {
        this.vnMappingService
          .updateVirtualNumberIVR(this.selectedId, updateData)
          .subscribe(
            (response) => {
              let responseData = response.body;
              if (responseData.responseCode == 200) {
                this.toastr.success('Virtual Number updated successfully');
                this.clearForm();
                this.isEdit = false;
                this.getVirtualNumbers();
                this.isLoading.next(false);
              } else {
                this.toastr.error(response.body.responseMessage);
                this.isLoading.next(false);
              }
            },
            (error) => {
              this.toastr.error('Error updating Virtual Number');
              this.isLoading.next(false);
            }
          );
      } else {
        this.vnMappingService
          .updateVirtualNumber(this.selectedId, updateData)
          .subscribe(
            (response) => {
              let responseData = response.body;
              if (responseData.responseCode == 200) {
                this.toastr.success('Virtual Number updated successfully');
                this.clearForm();
                this.isEdit = false;
                this.getVirtualNumbers();
                this.isLoading.next(false);
              } else {
                this.toastr.error(response.body.responseMessage);
                this.isLoading.next(false);
              }
            },
            (error) => {
              this.toastr.error('Error updating Virtual Number');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      const formData = this.virtualNumberForm.value;
      if (this.vnType == '2') {
        let obj = {
          virtual_number: formData.virtual_number,
          outlet_id: formData.outlet_id,
          lead_source: formData.lead_source || null,
          status: formData.status,
          lead_sub_source: formData.lead_sub_source || null,
          base_lead_source: formData.base_lead_source,
          fn_english_sales: formData.fn_english_sales,
          fn_english_non_sales: formData.fn_english_non_sales,
          fn_english_others: formData.fn_english_others,
          fn_hindi_sales: formData.fn_hindi_sales,
          fn_hindi_non_sales: formData.fn_hindi_non_sales,
          fn_hindi_others: formData.fn_hindi_others,
          fn_regional_sales: formData.fn_regional_sales,
          fn_regional_non_sales: formData.fn_regional_non_sales,
          fn_regional_others: formData.fn_regional_others
        };

        this.vnMappingService.createVirtualNumberIVR(obj).subscribe(
          (response) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
              this.toastr.success('Virtual Number created successfully');
              this.clearForm();
              this.isCreate = false;
              this.getVirtualNumbers();
              this.isLoading.next(false);
            } else {
              this.toastr.error(response.body.responseMessage);
              this.isLoading.next(false);
            }
          },
          (error) => {
            this.toastr.error('Error creating Virtual Number');
            this.isLoading.next(false);
          }
        );
      } else {
        let obj = {
          virtual_number: formData.virtual_number,
          outlet_id: formData.outlet_id,
          lead_source: formData.lead_source || null,
          status: formData.status,
          lead_sub_source: formData.lead_sub_source || null,
          base_lead_source: formData.base_lead_source,
          forwarding_number: formData.forwarding_number
        };

        this.vnMappingService.createVirtualNumber(obj).subscribe(
          (response) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
              this.toastr.success('Virtual Number created successfully');
              this.clearForm();
              this.isCreate = false;
              this.getVirtualNumbers();
              this.isLoading.next(false);
            } else {
              this.toastr.error(response.body.responseMessage);
              this.isLoading.next(false);
            }
          },
          (error) => {
            this.toastr.error('Error creating Virtual Number');
            this.isLoading.next(false);
          }
        );
      }
    }
  }

  edit(element: any) {
    this.isEdit = true;
    this.isCreate = false;
    this.selectedId = element.id;
    console.log(element)
    this.vnType = element?.ivr ? '2' : '1';
    if (element.ivr) {
      this.virtualNumberForm.patchValue({
        status: element.status ? 1 : 0,
        virtual_number: element.virtual_number,
        outlet_id: element.outlet_id,
        lead_source: element.lead_source_id || null,
        lead_sub_source: element.lead_sub_source_id || null,
        base_lead_source: element.base_lead_source_id,
        fn_english_sales: element.fn_english_sales || element.forwarding_number,
        fn_english_non_sales: element.fn_english_non_sales,
        fn_english_others: element.fn_english_others,
        fn_hindi_sales: element.fn_hindi_sales,
        fn_hindi_non_sales: element.fn_hindi_non_sales,
        fn_hindi_others: element.fn_hindi_others,
        fn_regional_sales: element.fn_regional_sales,
        fn_regional_non_sales: element.fn_regional_non_sales,
        fn_regional_others: element.fn_regional_others
      });
    }
    else {
      this.virtualNumberForm.patchValue({
        status: element.status ? 1 : 0,
        virtual_number: element.virtual_number,
        outlet_id: element.outlet_id,
        lead_source: element.lead_source_id || null,
        lead_sub_source: element.lead_sub_source_id || null,
        base_lead_source: element.base_lead_source_id,
        forwarding_number: element.forwarding_number,

      });
    }
    Object.keys(this.virtualNumberForm.controls).forEach(controlName => {
      if (controlName === 'status' || controlName === 'virtual_number') {
        this.virtualNumberForm.get(controlName)?.enable();
      } else {
        this.virtualNumberForm.get(controlName)?.disable();
      }
    });
  }

  clearForm() {
    this.submitted = false;
    this.virtualNumberForm.reset();
    this.virtualNumberForm.patchValue({ status: '', virtual_number: '', outlet_id: '', base_lead_source: '', lead_sub_source: '', lead_source: '' });
    this.selectedId = null;
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.getVirtualNumbers();
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public filterInput = new FormControl("");
  public searchInput = new FormControl("");
  applyFilter() {
    if (this.searchInput.value && this.searchInput.value?.length >= 3) {
      this.pageNumber = 1
      this.pageLimit = 10
      this.getVirtualNumbers();
    }
    if (!this.searchInput.value) {
      this.pageNumber = 1
      this.pageLimit = 10
      this.getVirtualNumbers();
    }
  }

  clearSearch() {
    this.pageNumber = 1
    this.pageLimit = 10
    this.searchInput.setValue('');
    this.getVirtualNumbers();
  }


  allowNumbersOnly(event: any) {
    this.sharedService.allowNumbersOnly(event);
  }

  goToImport() {
    this.router.navigateByUrl('/suzuki/vn-map-import');
  }
  onTypeChange() {
    this.submitted = false;
    if (this.vnType == '2') {
      this.virtualNumberForm.get('fn_english_sales')?.setValidators([Validators.required]);
      this.virtualNumberForm.get('fn_english_sales')?.updateValueAndValidity();

      this.virtualNumberForm.get('forwarding_number')?.clearValidators();
      this.virtualNumberForm.get('forwarding_number')?.updateValueAndValidity();
    } else {
      this.virtualNumberForm.get('fn_english_sales')?.clearValidators();
      this.virtualNumberForm.get('fn_english_sales')?.updateValueAndValidity();

      this.virtualNumberForm.get('forwarding_number')?.setValidators([Validators.required]);
      this.virtualNumberForm.get('forwarding_number')?.updateValueAndValidity();
    }
  }

  create() {
    this.submitted = false;
    this.selectedId = null;
    this.vnType = '';
     Object.keys(this.virtualNumberForm.controls).forEach(controlName => {
        this.virtualNumberForm.get(controlName)?.enable();
    });
  }
}
